import BgImg from '@assets/jpg/signup-bgs/step-2.jpeg';
import { ReactComponent as ErrorIcon } from '@assets/svg/form-error.svg';
import { ReactComponent as SuccessIcon } from '@assets/svg/form-success.svg';
import { Button } from '@components/ui';
import { AuthTitleSC } from '@pages/auth/auth.styled';
import AuthLayout from '@pages/auth/components/auth-layout';
import Header from '@pages/auth/components/header';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { ResetPasswordStatusSC } from './reset-password-status.styled';

const ResetPasswordStatus: React.FunctionComponent = () => {
  const { state } = useLocation<{ status: 'error' | 'success'; message?: string }>();
  const history = useHistory();
  const status = state?.status;

  React.useEffect(() => {
    if (!status) {
      history.replace('/login');
    }
  }, [status]);

  return (
    <AuthLayout backgroundImage={BgImg}>
      <div className="form-wrapper forgotten">
        <Header textId="forgotten_password_status.title" />
        <ResetPasswordStatusSC className="form">
          {status === 'success' ? (
            <>
              <SuccessIcon className="status-icon" />
              <AuthTitleSC className="center-text">
                <FormattedMessage id="forgotten_password_status.header_success" />
              </AuthTitleSC>
              <Button
                onClick={() => {
                  history.replace('/login');
                }}
              >
                <FormattedMessage id="forgotten_password_status.action_success" />
              </Button>
            </>
          ) : (
            <>
              <ErrorIcon className="status-icon" />
              <AuthTitleSC className="center-text">
                <FormattedMessage id="forgotten_password_status.header_error" />
              </AuthTitleSC>
              <p className="form-description center-text">
                <FormattedMessage id={`forgotten_password_status.${state?.message ?? 'general'}`} />{' '}
                <FormattedMessage
                  id="forgotten_password_status.contact"
                  values={{
                    address: (
                      <a href="mailto:info@hilbi.com?subject=Reset password">info@hilbi.com</a>
                    ),
                  }}
                />
              </p>
              <Button
                onClick={() => {
                  history.replace('/reset-password');
                }}
              >
                <FormattedMessage id="forgotten_password_status.action_error" />
              </Button>
            </>
          )}
        </ResetPasswordStatusSC>
      </div>
    </AuthLayout>
  );
};

export default React.memo(ResetPasswordStatus);
